import { es, pt, enUS } from 'date-fns/locale';

import { CalendarDay } from '@design-system/components/molecules/calendar/entities/calendar.types';

export type DateCalendarField = 'left' | 'right';

export type DateCalendarDefaultDates = [Date | null, Date | null];

export interface DateCalendarInputStringValues {
  left: string;
  right: string;
}

export interface DateCalendarInputBooleanValues {
  left: boolean;
  right: boolean;
}

export interface DateCalendarSelected {
  left: CalendarDay;
  right: CalendarDay;
}

export interface DateCalendarSelectedEvent extends DateCalendarSelected {
  field: DateCalendarField;
  days: number | null;
  nights: number | null;
}

export enum DateCalendarType {
  OnePage = 'one-page',
  TwoPages = 'two-pages',
  FullPage = 'full-page',
}

export type DateCalendarLocale = 'es' | 'pt' | 'enUS' | null | undefined;

export const DateCalendarLocaleValue = {
  es: es,
  pt: pt,
  enUS: enUS,
};

export const DateCalendarDefaultField = 'left';
export const DateCalendarDefaultOnlyOneDay = true;
export const DateCalendarAllowSameDateSelection = true;

export const DateCalendarOnePageCalendarScrollWidth = 366;
export const DateCalendarTwoPagesCalendarScrollWidth = 390;

export const DateCalendarOnePageMaxMonthsToScroll = 9;
export const DateCalendarTwoPagesMaxMonthsToScroll = 8;

export const DateCalendarOnePageCalendarWidth = '377px';
export const DateCalendarTwoPagesCalendarWidth = '780px';

export const DateCalendarPaginatedCalendarHeight = '420px';
export const DateCalendarPaginatedCalendarHeightWithInputs = '500px';
export const DateCalendarPaginatedCalendarPadding = '0 var(--spacing-nano)';
